export default __webpack_public_path__ + "static/media/Feature.a88702de.svg";